import { render, staticRenderFns } from "./SurveyWizard.vue?vue&type=template&id=1019804c&scoped=true"
import script from "./SurveyWizard.vue?vue&type=script&lang=js"
export * from "./SurveyWizard.vue?vue&type=script&lang=js"
import style0 from "./SurveyWizard.vue?vue&type=style&index=0&id=1019804c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1019804c",
  null
  
)

export default component.exports